module.exports = __webpack_public_path__ + "img/cross-icon.7f0ef38f.svg";